import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'
import pluralize from '../../utils/pluralize'
import getConstants from './constants'

import { defaultGetPageName } from '../../components/Post/utils'
import { runPostTypesConfig } from '../index'

import ContentComponent from './Content'
import getMenu, { getMenuProps } from './menu'

const objectIdPattern = /^[\da-fA-F]{24}$/

const postTypeConfig = {
    // A `_status` gyári szerepben marad: csak a törlés / visszaállítás használja.
    // A program menetét a `partnerState` mező tartja nyilván.
    getStatusManager: function getStatusManager(p = {}) {
        return defaultPostTypeConfig.getStatusManager(p)
    },
    getConstants: getConstants,
    setContents: function setContents(p = {}) {
        const { wapp } = p
        const name = 'partner'
        const n = name
        const N = capitalize(n)

        const r = defaultPostTypeConfig.setContents({
            ...p,
            name
        })

        let reqUserForPost = null

        wapp.contents.add({
            [name]: {
                ...wapp.contents.get(name),
                ComponentProps: {
                    TemplateProps: {
                        // A meghívó teljes képernyős felület; a lábléc alatta maradva
                        // egy második görgetősávot adna az oldalnak.
                        disableFooter: true
                    }
                },
                robots: () => {
                    return 'noindex,nofollow'
                },
                request: async function({ wapp, req, res }) {

                    const wappResponse = res.wappResponse
                    const route = wappResponse.route
                    const { params } = route
                    const { _id } = params
                    const requestName = _id?.match(objectIdPattern) ? name + 'FindById' : null

                    const statusManager = wapp.getTargetObject().postTypes.findPostType({ name: n }).statusManager
                    await runPostTypesConfig({
                        action: 'requestFor' + N + 'Page',
                        p: { wapp, req, res, statusManager }
                    })

                    if (requestName) {

                        const post = wappResponse.store.getState('res.responses.' + name + 'FindById')

                        const args = { _id }

                        if (
                            (reqUserForPost?._id !== req.wappRequest.user?._id) ||
                            (_id && !post) ||
                            (post?._id !== _id)
                        ) {
                            reqUserForPost = { _id: req.wappRequest.user?._id }
                            return await wapp.requests.send({ requestName, args, req, res })
                        }
                        return {
                            [requestName]: post
                        }

                    }
                }
            }
        })
        return r
    },
    requestForUserPage: async function requestForUserPage(p = {}) {

        const { req } = p
        const wappRequest = req.wappRequest
        const user = wappRequest.user
        const isAdmin = user && user._status_isFeatured

        if (isAdmin) {
            return await defaultPostTypeConfig.requestForUserPage({
                ...p,
                name: 'partner'
            })
        }

        return null
    },
    getComponent: function(p) {

        const name = 'partner'
        const ns = pluralize(name)

        const { context, appContext } = p
        const { routes } = appContext

        const { res, req } = context
        const route = res.wappResponse.route
        const requestPath = route.requestPath
        const user = req.wappRequest.user

        const isAdmin = user && user._status_isFeatured

        if ((requestPath.startsWith(routes[name + 'Route'])) || (requestPath.startsWith(routes[ns + 'Route']))) {

            const pages = {
                content: ContentComponent
            }

            // /partners - csak admin
            if (requestPath.startsWith(routes[ns + 'Route']) && !isAdmin) {
                return null
            }

            // /partner/new - csak admin
            if (requestPath === routes[name + 'Route'] + '/new' && !isAdmin) {
                return defaultPostTypeConfig.getComponent({
                    ...p,
                    name,
                    componentProps: { pages, getPageName: () => 'notFound' }
                })
            }

            const requestKeys = [name + 'FindById']

            return defaultPostTypeConfig.getComponent({
                ...p,
                name,
                componentProps: {
                    pages,
                    getPageName: defaultGetPageName,
                    requestKeys,
                    getMenu,
                    getMenuProps
                },
                archiveComponentProps: {
                    selectable: false,
                    getMenu: (p) => getMenu(p).map((m) => {
                        delete m.featured
                        return m
                    })
                }
            })
        }
    },
    userPageFunctions: function(p) {

        const { context, postContext } = p

        const n = 'partner'
        const ns = pluralize(n)
        const N = capitalize(n)
        const Ns = capitalize(ns)

        const r = defaultPostTypeConfig.userPageFunctions({
            ...p,
            name: n,
            nsPageProps: {
                selectable: false,
                type: 'list',
                disablePageInfo: true,
                getMenu,
                getMenuProps,
                ...p.nsPageProps ? p.nsPageProps : {}
            }
        })

        const { res } = context

        const wappResponse = res.wappResponse
        const route = wappResponse.route
        const { params } = route
        const { pageType } = params

        function addMenuItems(props) {
            const { appContext } = props
            const { menus, routes } = appContext

            // A `p.user` a BEJELENTKEZETT látogató, a `p.post` a megnyitott felhasználó.
            // Minden partner-dokumentum szerzője admin, ezért a menü csak akkor értelmes,
            // ha a megnyitott felhasználó maga is admin - egy munkáltató oldalán biztosan
            // üres listára vinne.
            const viewerIsAdmin = (p) => !!(p.user?._id && p.user._status_isFeatured)
            const viewedUserIsAdmin = (p) => !!p.post?._status_isFeatured
            const showPartners = (p) => viewerIsAdmin(p) && viewedUserIsAdmin(p)
            // Új partnert - a többi posttípus `new` menüpontjához hasonlóan - csak a
            // saját oldalán vehet fel valaki.
            const isOwnPage = (p) => !!(p.user?._id && (p.user._id === p.post?._author || p.user._id === p.post?._author?._id))

            return [
                {
                    label: function() {
                        return menus[ns + 'Menu']
                    },
                    role: function(p) {
                        return showPartners(p)
                    },
                    order: 131,
                    items: [
                        {
                            label: menus['new' + N + 'Menu'],
                            href: routes[n + 'Route'] + '/new',
                            role: function(p) {
                                return viewerIsAdmin(p) && isOwnPage(p)
                            },
                            disableParentRoute: true
                        },
                        {
                            label: menus[ns + 'Menu'],
                            href: function(p) {
                                return (p.post?._id) ? '/' + p.post._id + routes[postContext.name + Ns + 'Route'] : routes[postContext.name + Ns + 'Route']
                            },
                            role: function(p) {
                                return showPartners(p)
                            }
                        },
                        {
                            divider: true,
                            role: function(p) {
                                return showPartners(p)
                            }
                        },
                        {
                            label: function() {
                                return menus['deleted' + Ns + 'Menu']
                            },
                            href: function(p) {
                                return (p.post?._id) ? '/' + p.post._id + routes[postContext.name + Ns + 'Route'] + '/deleted' : routes[postContext.name + Ns + 'Route'] + '/deleted'
                            },
                            role: function(p) {
                                return showPartners(p)
                            }
                        }
                    ]
                }
            ]
        }

        function addContentMenuItems() {
            return []
        }

        function getPageName({ user, post, page }) {

            const isAdmin = user && user._status_isFeatured

            return (
                (page === ns && !pageType) ||
                (page === ns && !isNaN(Number(pageType)) && Number(pageType) >= 1) ||
                (page === ns && pageType === 'deleted')
            ) ? (isAdmin) ? page : 'notFound' : null
        }

        return {
            ...r,
            addMenuItems,
            addContentMenuItems,
            getPageName
        }
    },
    adminMenu: function(p) {
        const name = 'partner'
        const ns = pluralize(name)
        const { appContext } = p
        const { routes } = appContext

        const defaultAdminMenu = defaultPostTypeConfig.adminMenu({ ...p, name })
        defaultAdminMenu.order = 131

        // A `_status` gyári szerepben marad (csak törlés / visszaállítás), a `ban` és a
        // `featured` resolver le van tiltva. A "hiányzó adatok" lista is értelmét vesztette,
        // mert a program menetét a `partnerState` mező vezeti, nem a státusz.
        const removedHrefs = [
            routes[ns + 'Route'] + '/banned',
            routes[ns + 'Route'] + '/protected',
            routes[ns + 'Route'] + '/missingdata'
        ]

        defaultAdminMenu.items = (defaultAdminMenu.items || []).filter((item) => {
            const href = typeof item.href === 'function' ? item.href() : item.href
            return !removedHrefs.includes(href)
        })

        return defaultAdminMenu
    }
}

export default postTypeConfig
